module.exports = __webpack_public_path__ + "img/CirillaRiannon.702daca.png";